import React from 'react';
import { Card, CardHeader, CardText } from 'material-ui/Card';

const About = () => (

  <Card className="unregistered">
    <CardHeader title="About Pronounce Live" />
    <CardText>

      <p>Sanako Pronounce Live is a true online solution for pronunciation practice, no installations or downloads are needed.</p>

      <p>Pronounce Live requires the Google Chrome browser.</p>

      <h3>About Sanako Corporation</h3>

      <p>Sanako is the global leader in developing language teaching software and services for the educational sector. We have worked closely with our customers for over 50 years towards a single goal: to enable better comprehension, speaking and communication skills for language learners.</p>

      <p>Sanako Corporation is a global organization employing professionals on four continents. Our headquarters is located in Finland. Our network of partners worldwide ensures we are always close to our customers.</p>

      <h3>Contact Us</h3>

    <h4>Personal users</h4>
    <p>If you have any questions, please check our <a target="_blank" href="http://www.sanako.com/help/pronounce-live-faq/">FAQ</a> first.</p>
    <p>If the FAQ doesn't answer your question, you can contact us at <a href="mailto:pronouncelive@sanako.com">pronouncelive@sanako.com</a>.</p>

    <h4>Institutions</h4>

      <p>Pronounce Live is available for institutions also. You can contact us for more information at:</p>

      <p><a href="mailto:pronouncelive@sanako.com">pronouncelive@sanako.com</a></p>

      <p>Our reseller network around the world is ready to serve you. You can find the complete list of Sanako resellers at:</p>

      <p><a href="http://www.sanako.com/resellers/">http://www.sanako.com/resellers/</a></p>

      <p>Don&rsquo;t hesitate to contact us if you cannot find a reseller or you want us to find the most suitable partner for you.</p>
    </CardText>
  </Card>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js